export interface Sorting {
  sortBy: string;
  descending: boolean;
}

export interface Paging {
  pageNumber: number;
  pageSize: number;
}

export type GridFilterValue = string[] | number[] | Date[];

export interface GridFilters {
  [key: string]: GridFilterValue;
}

export const DEFAULT_PAGE_SIZE = 20;

export class GridQuery implements Sorting, Paging {
  constructor(
    public pageNumber: number = 1,
    public pageSize: number = DEFAULT_PAGE_SIZE,
    public sortBy: string = null,
    public descending: boolean,
    public filters: GridFilters = {},
    public searchText?: string
  ) {}
}
